import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

// Components
import { blobURL } from "common/StringUtils";
import Layout from "../Layout";
import { useSelector } from "react-redux";
import { LOCALES } from "common/constants";

const ManinHealthInsurance = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);

  const mainpagehealthEng = `${blobURL}/HealthInsuranceEnglish.jpg`;
  const mainpagehealthSwe = `${blobURL}/HealthInsuranceswedish.jpg`;

  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const Healthcare = () => {
    return (
      <>
        <Helmet>
          <title>{t("Health Insurance | Invozio")}</title>
          {language === LOCALES.EN_US ? (
            <link
              rel="canonical"
              href="https://invozio.com/health-insurance-main"
            />
          ) : (
            <link
              rel="canonical"
              href="https://invozio.com/sjukforsakring-huvud"
            />
          )}
          <meta name="robots" content="index, follow" />
        </Helmet>

        <Container className="p-0 self_new negotiate neg_rspn health-insurance-top-section mx-auto">
          <header className="new-header">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 px-md-5 px-sm-3 px-4">
                  <h1 className="purple">{t("Health Insurance")}</h1>
                  <p className="my-">
                    {t(
                      "A health insurance plan is an important complement to the general sickness benefits provided by Försäkringskassan. Compensation is paid out after a 90-day waiting period, every month, and for as long as the sick leave lasts. Through Invozio, you can take out private health insurance with the same compensation level as the ITP plan for salaried employees. The insurance is signed and paid for privately via our agreement with Euro Accident. If you are interested in a quote/application"
                    )}
                    <span>
                      {t("you can")}
                      <Link
                        to={
                          language === LOCALES.EN_US
                            ? `/health-insurance?lang=${LOCALES.EN_US}`
                            : `/sjukforsakring?lang=${LOCALES.SV_SE}`
                        }
                        style={{ textDecoration: "underline" }}
                      >
                        <strong className="ml-1">{t("Click here")}</strong>
                      </Link>
                    </span>
                  </p>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="healthhero-image">
                    <img
                      alt=""
                      src={
                        language === LOCALES.EN_US
                          ? mainpagehealthEng
                          : mainpagehealthSwe
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </header>
        </Container>
      </>
    );
  };

  return (
    <>
      {user ? (
        <Layout className="my-customers-table" showSidebar bgcolor>
          {Healthcare()}
        </Layout>
      ) : (
        <Layout
          className="p-0 my-customers-table"
          dashboardFooter={dashboardFooter}
        >
          {Healthcare()}
        </Layout>
      )}
    </>
  );
};

export default ManinHealthInsurance;
